<template>
  <section v-if="items.length" :id="sectionId" class="stats-section">
    <v-container>
      <p class="section-kicker">{{ kicker }}</p>
      <h2>{{ title }}</h2>
      <div class="stats-grid">
        <article v-for="item in items" :key="item.id" class="stat-card">
          <v-icon v-if="item.icon" class="stat-icon">{{ item.icon }}</v-icon>
          <strong>{{ item.value }}<small v-if="item.suffix">{{ item.suffix }}</small></strong>
          <span>{{ item.label }}</span>
        </article>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'EventStats',
  props: {
    items: { type: Array, default: () => [] },
    title: { type: String, required: true },
    kicker: { type: String, default: 'By the Numbers' },
    sectionId: { type: String, default: '' },
  },
};
</script>

<style scoped>
.stats-section { background: #050505; border-top: 1px solid #202020; padding: 64px 0; }
.section-kicker { color: #e23232; font-family: "Oswald", sans-serif; font-weight: 800; text-transform: uppercase; }
h2 { color: #fff; font-family: "Oswald", sans-serif; font-size: clamp(2rem, 5vw, 3rem); margin: 0 0 24px; }
.stats-grid { display: grid; gap: 12px; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); }
.stat-card { background: linear-gradient(145deg, #171717, #0b0b0b); border: 1px solid #2d2d2d; border-radius: 10px; min-height: 145px; padding: 22px; }
.stat-icon { color: #f0b13c !important; margin-bottom: 20px; }
.stat-card strong { color: #fff; display: block; font-family: "Oswald", sans-serif; font-size: 1.65rem; line-height: 1.1; }
.stat-card small { font-size: 0.85rem; }
.stat-card span { color: #aaa; display: block; font-size: 0.82rem; font-weight: 700; margin-top: 8px; text-transform: uppercase; }
</style>
